import { combineReducers } from "redux";
import { loginReducer } from "./globalReducers/loginReducer";
import { smallBoatsReducer } from "./smallBoatsReducer/smallBoatsReducer";
import { certificateReducer } from "./certificateReducer/certificateReducer";
import { basesBuildingReducer } from "./baseBuildingReducer/basesBuildingReducer";
import { dictionaryReducer } from "./globalReducers/dictionaryReducer";
import { smallBoatsRegReducer } from "./SmallBoatsRegReducer/SmallBoatsRegReducer";
import { registrationInformationChangesReducer } from "./RegistrationInformationChangesReducer/RegistrationInformationChangesReducer";
import { tableReducer } from "./globalReducers/tableReducer";
import { statementReducer } from "./statementReducer/statementReducer";
import { DuplicateShipsTicketReducer } from "./DuplicateShipsTicketReducer/DuplicateShipsTicketReducer";
import { ShipsTicketReducer } from "./ShipsTicketReducer/ShipsTicketReducer";
import { provisionInformationReducer } from "./provisionInformationReducer/provisionInformationReducer";
import { TransportAccidentsReportReducer } from "./TransportAccidentsReportReducer/TransportAccidentsReportReducer";
import { TechnicalExaminationReducer } from "./TechnicalExaminationReducer/TechnicalExaminationReducer";
import { applicationTrainingReducer } from "./applicationTrainingReducer/applicationTrainingReducer";
import { expulsionOrderReducer } from "./expulsionOrderReducer/expulsionOrderReducer";
import { searchListenerReducer } from "./searchListenerReducer/searchListenerReducer";
import { editableTableReducer } from "./editableTableReducer/editableTableReducer";
import { recordTrainedUsersReducer } from "./recordTrainedUsersReducer/RecordTrainedUsersReducer";
import { appKnowledgeVerificationReducer } from "./appKnowledgeVerificationReducer/appKnowledgeVerificationReducer";
import { issuingCertificatesReducer } from "./issuingCertificatesReducer/issuingCertificatesReducer";
import { printCertificatesReducer } from "./printCertificatesReducer/printCertificatesReducer";
import { authLoginReducer } from "./loginReduser/loginReduser";
import { knowledgeTestRecordReducer } from "./knowledgeTestRecordReducer/knowledgeTestRecordReducer";
import { inspectionTechnicalConditionBasesReducer } from "./inspectionTechnicalConditionBasesReducer/inspectionTechnicalConditionBasesReducer";
import { exchangeCertificatesReducer } from "./exchangeCertificatesReducer/exchangeCertificatesReducer";
import { logbookAdministrativeProceduresReducer } from "./logbookAdministrativeProceduresReduser/logbookAdministrativeProceduresReduset";
import { gimsDepartmentReducer } from "./directoryMaintenance/structuralUnitsReducer/StructuralUnitsReducer";
import { gimsSectionsReducer } from "./directoryMaintenance/gimsSectionsReducer/gimsSectionsReducer";
import { administrativeDistrictsReducer } from "./directoryMaintenance/administrativeDistrictsReducer/administrativeDistrictsReducer";
import { positionsReducer } from "./directoryMaintenance/positionsReducer/positionsReducer";
import { swimmingDifficultyCategoryReducer } from "./directoryMaintenance/swimmingDifficultyCategoryReducer/swimmingDifficultyCategoryReducer";
import { preparationProgramsReducer } from "./directoryMaintenance/preparationProgramsReducer/preparationProgramsReducer";
import { paymentDetailsReducer } from "./directoryMaintenance/paymentDetailsReducer/paymentDetailsReducer";
import { settlementsReducer } from "./directoryMaintenance/settlementsReducer/settlementsReducer";
import { identificationDocumentsReducer } from "./directoryMaintenance/indentificationDocumentsReducer/identificationDocumentsReducer";
import { boatTypesReducer } from "./directoryMaintenance/boatTypesReducer/boatTypesReducer";
import { medConditionsReducer } from "./directoryMaintenance/medConditionsReducer/medConditionsReducer";
import { trainingDocTypesReducer } from "./directoryMaintenance/trainingDocTypesReducer/trainingDocTypesReducer";
import { engineTypesReducer } from "./directoryMaintenance/engineTypesReducer/engineTypesReducer";
import { boatBodyMaterialReducer } from "./directoryMaintenance/boatBodyMaterialReducer/boatBodyMaterialReducer";
import { kindsBoatsReducer } from "./directoryMaintenance/kindsBoatsReducer/kindsBoatsReducer";
import { accountManagementReducer } from "./accountManagementReducer/accountManagementReducer";
import { auditActionSystemReducer } from "./auditActionsSystemReducer/auditActionsSystemReducer";
import { auditSecurityReducer } from "./auditSecurityReducer/auditSecurityReducer";
import { roleManagementReducer } from "./roleManagementReducer/roleManagementReducer";
import { userReducer } from "./userReducer/userReducer";
import { roleControllerReducer } from "./roleControllerReducer/roleControllerReducer";
import { rangeMSReducer } from "./directoryMaintenance/rangeMS/rangeMSReducer";
import { duplicateCertificatesReducer } from "./duplicateCertificatesReducer/duplicateCertificatesReducer";
import { viewReducer } from "./viewReducer/viewReducer";
import { patternsReducer } from "./patternsReducer/patternsReducer";
import registrationChangesInformationRHFReducer from "./RegistrationChangesInformationRHFReducer/registrationChangesInformationRHFReducer";
import { rayonAndRegionReducer } from "./rayonAndRegionReducer/rayonAndRegionReducer";
import { countriesReducer } from "./directoryMaintenance/countriesReducer/countriesReducer";
import { organizationsReducer } from "./directoryMaintenance/organizationsReducer/organizationsReducer";

export const rootReducer = combineReducers({
  loginReducer,
  smallBoatsReducer,
  certificateReducer,
  dictionaryReducer,
  basesBuildingReducer,
  smallBoatsRegReducer,
  tableReducer,
  registrationInformationChangesReducer,
  statementReducer,
  DuplicateShipsTicketReducer,
  ShipsTicketReducer,
  provisionInformationReducer,
  TransportAccidentsReportReducer,
  TechnicalExaminationReducer,
  applicationTrainingReducer,
  expulsionOrderReducer,
  searchListenerReducer,
  editableTableReducer,
  recordTrainedUsersReducer,
  appKnowledgeVerificationReducer,
  issuingCertificatesReducer,
  knowledgeTestRecordReducer,
  authLoginReducer,
  printCertificatesReducer,
  inspectionTechnicalConditionBasesReducer,
  exchangeCertificatesReducer,
  logbookAdministrativeProceduresReducer,
  gimsDepartmentReducer,
  gimsSectionsReducer,
  administrativeDistrictsReducer,
  positionsReducer,
  swimmingDifficultyCategoryReducer,
  preparationProgramsReducer,
  paymentDetailsReducer,
  settlementsReducer,
  identificationDocumentsReducer,
  boatTypesReducer,
  medConditionsReducer,
  trainingDocTypesReducer,
  engineTypesReducer,
  boatBodyMaterialReducer,
  kindsBoatsReducer,
  accountManagementReducer,
  auditActionSystemReducer,
  auditSecurityReducer,
  roleManagementReducer,
  userReducer,
  roleControllerReducer,
  duplicateCertificatesReducer,
  rangeMSReducer,
  viewReducer,
  patternsReducer,
  registrationChangesInformationRHFReducer,
  rayonAndRegionReducer,
  countriesReducer,
  organizationsReducer,
});
